import styled from 'styled-components';
import { BottomSns } from '../../common/BottomSnsImg';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery, openKakaoLink } from '../../../utils';

export const RewardInfo = () => {
  return (
    <>
      <Wrap>
        <LabelRed>
          <LabelText>온라인 새틀라이트</LabelText>
        </LabelRed>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>새틀 for 새틀</EventTitleRed>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>
              12월 29일(월) ~ 1월 22일(목)
              <br />
              매일 오후 6시 (주말 프리롤)
            </EventDate>
            <EventVenueContainer>
              <img src={ImageUtils.ShowDownApp} alt="" />
              <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>
        </EventRow>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>새틀라이트</EventTitleRed>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>
              12월 29일(월) ~ 1월 22일(목)
              <br />
              매일 오후 8시, 오후 10시
            </EventDate>
            <EventVenueContainer>
              <img src={ImageUtils.ShowDownApp} alt="" />
              <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>
        </EventRow>

        <LabelGreen>
          <LabelText>오프라인 이벤트</LabelText>
        </LabelGreen>
        <CongressOfflineContainer>
          <FullText>2026 TMT 19 ‘Main Event’ Day 1</FullText>
          <DayContainer>
            <DayText>1월 24일(토)</DayText>
            <DayText>오후 1시</DayText>
          </DayContainer>
          <LocationContainer>
            <CircleLocation>ES Studio 수원</CircleLocation>

            <LocationText>경기도 수원시 팔달구 인계로 94번길 27-27 2층</LocationText>
          </LocationContainer>
        </CongressOfflineContainer>

        <PartnerWrap>
          <PartnerContainer>
            <PartnerTitle>주최 / 주관</PartnerTitle>
            <PartnerContent>
              <img src={ImageUtils.PartnerIcon} alt="" />
            </PartnerContent>
          </PartnerContainer>

          <RequestKakaoContainer>
            <RequestText>
              자세한 내용은 <Br />
              <span onClick={openKakaoLink}>TMT 카카오톡 채널</span>에 <Br />
              문의해주세요!
            </RequestText>

            <img src={ImageUtils.KakaoIcon} alt="" />
          </RequestKakaoContainer>
        </PartnerWrap>
      </Wrap>
      <BottomSns />
    </>
  );
};

const Br = styled.br`
  display: block;
  ${mobileQuery} {
    display: none;
  }

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const RequestKakaoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30px;

  border-top: 2px solid rgba(0, 0, 0, 0.5);

  border-bottom: 2px solid rgba(0, 0, 0, 0.5);

  background: #222;

  height: 170px;
  flex: 1;

  ${mobileQuery} {
    border-top: 1px solid rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
    padding-left: 15px;
    padding-right: 15px;
    height: 88px;
    img {
      width: 40px;
    }
  }
`;
const RequestText = styled.p`
  text-align: left;
  margin-right: 30px;

  color: rgba(255, 255, 255, 0.8);
  font-family: 'Noto Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 125% */

  span {
    color: #fae100;
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6%;
    text-underline-offset: 20%;
    cursor: pointer;
  }

  ${mobileQuery} {
    font-size: 12px;
    line-height: 15px;

    span {
      font-size: 12px;
      line-height: 15px;
    }
  }
`;

const DayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;

  ${mobileQuery} {
    margin-bottom: 5px;
    img {
      width: 12px;
    }
  }
`;

const DayText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  line-height: 32px;
  letter-spacing: -0.52px;

  margin-bottom: 10px;

  ${mobileQuery} {
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 10px;
    margin-top: 6px;

    span {
      font-size: 10px;
    }
  }
`;

const FullText = styled.h3`
  color: #00ffd4;
  font-size: 26px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: -1.04px;
  margin-bottom: 10px;
  text-align: left;

  span {
    font-size: 20px;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 10px;
    margin-top: 6px;

    span {
      font-size: 10px;
    }
  }
`;

const LocationContainer = styled.div`
  display: flex;

  ${mobileQuery} {
    align-items: center;
  }
`;

const CircleLocation = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.88px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(0, 0, 0, 0);
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  margin-right: 10px;
  flex-shrink: 0;

  ${mobileQuery} {
    font-size: 11px;
    line-height: 23px;
    padding-left: 10px;
    padding-right: 10px;
    margin-right: 5px;
    height: 24px;
  }
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  font-weight: 400;
  line-height: 30px; /* 125% */
  letter-spacing: -0.96px;
  text-align: left;

  ${mobileQuery} {
    font-size: 14px;
    line-height: 18px;
  }
`;

const Wrap = styled.div`
  padding-right: 90px;
  padding-left: 90px;
  padding-bottom: 170px;
  text-align: center;
  margin-top: 10px;

  ${mobileQuery} {
    padding-top: 15px;
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }
`;

const Label = styled.div`
  height: 50px;
  width: 100%;

  ${mobileQuery} {
    height: 25px;
  }
`;

const LabelRed = styled(Label)`
  border-top: 2px solid #d92a76;
  border-bottom: 1px solid #d92a76;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
  height: 42px;

  ${mobileQuery} {
    height: 24px;

    border-top: 1px solid #d92a76;
    border-bottom: 1px solid #d92a76;
  }
`;

const LabelGreen = styled(Label)`
  border-top: 2px solid #02b5b5;
  background: linear-gradient(91deg, #007d7d 10.71%, #006969 84.3%);

  height: 42px;
  ${mobileQuery} {
    height: 21px;
    border-top: 1px solid #02b5b5;
  }
`;

const LabelText = styled.p`
  font-weight: 600;
  font-size: 24px;
  line-height: 38px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;

  ${mobileQuery} {
    font-size: 15px;
    line-height: 20px;
  }
`;

const CongressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: #222;
  height: 136px;
  padding-left: 20px;
  padding-right: 20px;

  &:last-child {
    margin-bottom: 10px;
  }

  ${mobileQuery} {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 5px;
    height: 86px;

    &:last-child {
      margin-bottom: 5px;
    }
  }
`;

const CongressOfflineContainer = styled(CongressContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 13px;
  background-color: #222;
  height: 182px;
  padding-left: 20px;
  padding-right: 20px;

  ${mobileQuery} {
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 5px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const PartnerWrap = styled.div`
  display: flex;
`;

const PartnerContainer = styled.div`
  width: 293px;
  margin-right: 6px;
  margin-bottom: 2px;
  &:last-child {
    margin-right: 0;
  }

  ${mobileQuery} {
    width: 136px;
    margin-right: 3px;
  }
`;

const PartnerTitle = styled.h3`
  height: 40px;

  border-bottom: 1px solid #000000;
  background: rgba(0, 0, 0, 0.5);

  font-family: 'Gmarket';

  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.8px;
  line-height: 40px;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 25px;
    height: 20px;
  }
`;

const PartnerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 130px;

  background: rgba(0, 0, 0, 0.2);

  ${mobileQuery} {
    height: 69px;
    img {
      width: 70px;
    }
  }
`;

const EventRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  text-align: left;
  margin-bottom: 2px;
  background-color: #222;
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }

  ${mobileQuery} {
    padding: 0px 10px;
    padding-top: 5px;
    padding-bottom: 6px;
  }
`;

const EventInfoLeft = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

const EventInfoRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const EventTitleRed = styled.h3`
  font-size: 20px;
  font-weight: 400;
  color: #ff63a2;

  ${mobileQuery} {
    font-size: 14px;
  }
`;

const EventDate = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  span {
    font-weight: 700;
  }

  ${mobileQuery} {
    font-size: 13px;
  }
`;

const EventVenueContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  img {
    display: none;
  }

  ${mobileQuery} {
    img {
      display: block;
      width: 34px;
      margin-bottom: 2px;
    }
  }
`;

const EventVenue = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${mobileQuery} {
    font-size: 13px;
  }
`;
